import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import PublicRoute from './PublicRoute'
import {fetchUser, USER} from '../../../redux/actions/app/user/user.actions'
import {getLogin, getLoadingEntity} from '../../../redux/selectors/ui/ui.selectors'
import {APP_URL_PASS} from "../../../config/constants";

const mapStateToProps = state => {
    return {
        login: getLogin(state),
        checking: getLoadingEntity(state, USER)
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    // ?provider=pros vérifie que l'utilisateur est bien un Pro (pas un Customer)
    checkAuth: () => fetchUser({query: `${APP_URL_PASS}/user?refresh=true&provider=pros`})
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PublicRoute)
